import { Injectable } from '@angular/core'

/** Keeps inline list search text while a user opens and closes an entity detail view. */
@Injectable({ providedIn: 'root' })
export class InlineListSearchService {
  private readonly terms = new Map<string, string>()

  /**
   * Returns the last search text for one entity list.
   * @param {string} key Entity list key.
   * @returns {string}
   */
  get(key: string): string {
    return this.terms.get(key) ?? ''
  }

  /**
   * Stores search text for one entity list.
   * @param {string} key Entity list key.
   * @param {string} value Search text.
   */
  set(key: string, value: string): void {
    this.terms.set(key, value.trim())
  }
}
